export default "__VITE_PUBLIC_ASSET__b5409303__"